export default __webpack_public_path__ + "static/media/22g1881vb.07c2c5dc.jpeg";